import React from 'react';
import PropTypes from 'prop-types';
import cancelEvent from '../../../services/mini/cancelEvent';

class FilterByLine extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.onClick = this.onClick.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        let curProps = this.props;

        if (curProps.line !== nextProps.line) {
            return true;
        }

        return false;
    }

    onClick(e) {
        cancelEvent(e);
    }

    render() {
        let {
            line,
            classes
        } = this.props;

        return <div className={`filter-by-line ${line && 'has-line'} ${classes}`}
                    onClick={this.onClick}>
            <div>Filtered: line {line}</div>
            <i className="icon icon-alan-remove-fat" onClick={this.props.resetLineFilter}/>
        </div>;
    }
}

FilterByLine.propTypes = {
    line: PropTypes.number,
    classes: PropTypes.string,
    resetLineFilter: PropTypes.func.isRequired,
};

export default FilterByLine;